import ApiConfig from "../config/ApiConfig";

const countyUrl = new URL(
  ApiConfig.protocol +
    ApiConfig.apiUri +
    ApiConfig.irqInfoEndpoint +
    "/counties"
);

async function getCountyLimits() {
  try {
    const response = await fetch(countyUrl);
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.log(error);
  }
}

export default getCountyLimits;
